import { memo, useCallback } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";
import { Menu, MenuItem, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

const FileListItemMenu = () => {
  const d = useAppDispatch();
  const [t] = useTranslation();
  const [open, top, left, imageId, image] = useAppSelector((state) => {
    const imageId = store.getAppState(state, "openImageMenuId");
    return [
      store.getAppState(state, "openImageMenu"),
      store.getAppState(state, "anchorTop"),
      store.getAppState(state, "anchorLeft"),
      imageId,
      store.getUserFileById(state, imageId || ""),
    ] as const;
  }, shallowEqual);
  const onClose = useCallback(() => {
    d(store.appStateMutate((state) => (state.openImageMenu = false)));
  }, [d]);
  const onDelete = useCallback(() => {
    if (
      imageId &&
      window.confirm(
        t(
          "ファイルを完全に削除します。この画像が参照されていた場合、表示できなくなります。"
        )
      )
    ) {
      d(store.deleteUserFile2(imageId));
    }
    onClose();
  }, [imageId, d, t, onClose]);
  const onArchive = useCallback(() => {
    if (imageId) {
      d(store.archiveUserFile(imageId));
      onClose();
    }
  }, [imageId, d, onClose]);
  const onShowImage = useCallback(() => {
    d(
      store.appStateMutate((state) => {
        state.openInspector = true;
        state.inspectImageUrl = image?.url || null;
      })
    );
    onClose();
  }, [image?.url, d, onClose]);

  return (
    <Menu
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={{ top, left }}
      MenuListProps={{ dense: true }}
      onClose={onClose}
    >
      <MenuItem onClick={onShowImage}>{t("拡大表示")}</MenuItem>
      <Divider style={{ marginTop: 8, marginBottom: 8 }} />
      <MenuItem onClick={onArchive}>{t("アーカイブ")}</MenuItem>
      <MenuItem onClick={onDelete}>{t("削除")}</MenuItem>
    </Menu>
  );
};

export default memo(FileListItemMenu);
